import React, { useState, useMemo, useEffect } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { ApiService } from '../api';
import {useNavigate} from 'react-router-dom';
import { accessTokenState, refreshTokenState, expireState, updateTimeState } from '../atom/TokenAtom';

const useTokenUpdate = () => {
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [updateTime, setUpdateTime] = useRecoilState(updateTimeState);
    const [expire, setExpire] = useRecoilState(expireState);

    const api = useMemo(() => new ApiService(), []);

    const navigate = useNavigate();

    const tokenUpdate = async () => {
        try {
            if (!refreshToken) return;
            const newToken = await api.getNewToken(refreshToken);
            setAccessToken(newToken.accessToken);
            setRefreshToken(newToken.refreshToken);
            setExpire(newToken.expire); 
            setUpdateTime(Date.now());
        }
        catch(err: any) {
            localStorage.clear();
            navigate('/login');
        }
    }

    useEffect(() => {
        const checkAndUpdateToken = () => {
            const now = Date.now();
            const updateTimeThreshold = 1000 * 60 * 15;
            if (now - Number(updateTime) > updateTimeThreshold) {
                tokenUpdate();
            }
        };

        // const interval = setInterval(checkAndUpdateToken, 1000 * 60);
        const interval = setInterval(checkAndUpdateToken, 1000 * 60 * 10);
        return () => clearInterval(interval);
    }, [updateTime]);

    return null;
}

export default useTokenUpdate;